import { render, staticRenderFns } from "./EC06TF.vue?vue&type=template&id=b8060d96&"
import script from "./EC06TF.vue?vue&type=script&lang=js&"
export * from "./EC06TF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports